module.exports = __webpack_public_path__ + "img/radiaIcon3.ceca15c5.svg";